'use strict';

var ColumnCustomizationDirective = function ColumnCustomizationDirective(angularHelper, $timeout) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/column-customization.html'),
    controller: 'ColumnCustomizationController',
    require: '^rmGridPanel',
    scope: {
      settings: '=',
      applicationDefaultSettings: '=',
      applyChangesCallback: '=',
      fields: '=',
      isEditing: '@',
      isEditingGroup: '@',
      isEditingColumn: '@',
      editValues: '@',
      isValid: '@'
    },
    link: function link(scope, element) {
      element.on('shown.bs.modal', function () {
        scope.isJqxTreeVisible = true;
        angularHelper.triggerDigest(scope);
        $timeout(function () {
          scope.rebuildTree(scope.settings);
          scope.openDialogActions();
          scope.determineButtonsAvailability();
          scope.determineEditPanelVisibility();
          angularHelper.triggerDigest(scope);
        });
      });
      element.on('hidden.bs.modal', function () {
        scope.closeDialogActions();
      });
      element.on('dragEnd', function () {
        scope.treeSettings.apply('refresh');
        scope.updateTreeModelAfterDragAndDrop();
        angularHelper.triggerDigest(scope);
      });
      element.on('checkChange', function (event) {
        scope.onCheckChange(event);
        angularHelper.triggerDigest(scope);
      });
      element.on('select', function (event) {
        if (event.args) {
          scope.onSelect(event.args.element.id);
          angularHelper.triggerDigest(scope);
        }
      });
      scope.$watch('editValues', scope.editValuesWatcher, true);
      scope.$watch(scope.determineButtonsAvailability);
    }
  };
};
ColumnCustomizationDirective.$inject = ['AngularHelper', '$timeout'];
module.exports = ColumnCustomizationDirective;